import api from '../lib/utils/apiConfig';

const portfolioService = {
  getPortfolios: async (search) => {
    const response = await api.get('/portfolio', { params: { search } });
    return response.data;
  },

  createPortfolio: async (payload) => {
    const response = await api.post('/portfolio', payload);
    return response.data;
  },

  updatePortfolio: async (id, payload) => {
    const response = await api.put(`/portfolio/${id}`, payload);
    return response.data;
  },

  getPortfolioById: async (id) => {
    const response = await api.get(`/portfolio/${id}`);
    return response.data;
  },

  deletePortfolio: async (id) => {
    const response = await api.delete(`/portfolio/${id}`);
    return response.data;
  },

  reorderPortfolios: async (items) => {
    const response = await api.put('/portfolio/reorder/bulk', { items });
    return response.data;
  }
};

export default portfolioService;
